import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import * as yup from 'yup';
import { Box } from '@material-ui/core';
import { Button, ReactFormInput, ReactHookFormModal } from '../../../../components';
import { selectIsProjectOwner, selectProject } from '../../../../store/modules/projects/selectors';
import { selectCancelOrder, selectOrder } from '../../../../store/modules/orders/selectors';
import { useActionDispatcher, useGuard } from '../../../../hooks';
import { is, roles } from '../../../../utility/guard';
import { cancelOrderRequest } from '../../../../store/modules/orders/actions';
import { CancelOrderForm } from '../../../../store/modules/orders/types';

const cancelVideoEditOrderSchema = yup.object().shape({
  notes: yup.string().required().trim(),
});

const CancelVideoEditOrderButton = () => {
  const { data: project } = useSelector(selectProject);
  const { data: order } = useSelector(selectOrder);
  const { order_id: orderId } = useParams<{ order_id: string }>();
  const [open, setOpen] = useState(false);
  const createScene = useActionDispatcher(cancelOrderRequest);
  const statusId = order?.status_id;
  const { loading } = useSelector(selectCancelOrder);
  const isSuperAdmin = useGuard(is(roles.superAdmin));
  const isProjectOwner = useSelector(selectIsProjectOwner);
  const isVisibleForCurrentUser = isSuperAdmin || (isProjectOwner && statusId === 'in_progress');

  const initialValues: CancelOrderForm = {
    order_id: parseInt(orderId, 10),
    notes: '',
  };

  if (!project || !order || statusId === 'cancelled' || !orderId || !isVisibleForCurrentUser) {
    return null;
  }

  return (
    <>
      <Button styleButton="orange" onClick={() => setOpen(true)}>
        Cancel Order
      </Button>
      {open && (
        <ReactHookFormModal
          open={open}
          title="Cancel Order"
          onCloseHandler={() => setOpen(false)}
          formSettings={{
            initialValues,
            validationSchema: cancelVideoEditOrderSchema,
            onSubmit: createScene,
            creatingMode: true,
            loading,
            hideCancel: true,
            submitTitle: 'Cancel Order',
          }}
        >
          <>
            <Box mb={2}>This order has not been processed so you will not be charged credits or fees.</Box>
            <ReactFormInput autoFocus name="notes" label="Notes" />
          </>
        </ReactHookFormModal>
      )}
    </>
  );
};

export default CancelVideoEditOrderButton;
